import axios from 'axios';
import qs from 'qs';
import * as Sentry from '@sentry/browser';
import { projectUrl, sentryDns } from '../config';
import Cookie from '../_utils/cookie';

const csrftoken = new Cookie('csrftoken');

Sentry.init({ dsn: sentryDns });

/**
 * parse error response
 */
function parseError (status, messages) {
  // error
  if (status === 404) messages = gettext('Объект не найден');
  if (status === 403 && messages['detail']) messages = messages['detail'];
  if (messages) {
    if (!window.debug) Sentry.captureException(messages);
    if (messages instanceof Array) {
      return Promise.reject({ messages: messages })
    } else {
      return Promise.reject({ messages: [messages] })
    }
  } else {
    return Promise.reject({ messages: [gettext('Неизвестная ошибка')] })
  }
}

/**
 * parse response
 */
function parseBody (response) {
//  if (response.status === 200 && response.data.status.code === 200) { // - if use custom status code
  if ([200, 201, 204].includes(response.status)) {
    return response.data
  } else {
    return this.parseError(response.status, response.data.messages)
  }
}

/**
 * axios instance
 */
let instance = axios.create({
  withCredentials: true,
  baseURL: projectUrl + '/' + window.lang + '/api/',
  paramsSerializer: function (params) {
    return qs.stringify(params, { indices: false })
  }
})

// request header
instance.interceptors.request.use((config) => {
  // Do something before request is sent
  if (['post', 'delete', 'patch', 'put'].includes(config.method)){
    config.headers = { 'X-CSRFToken': csrftoken.get() }
  }
  return config
}, error => {
  return Promise.reject(error)
})

// response parse
instance.interceptors.response.use((response) => {
  return parseBody(response)
}, error => {
  console.warn('Error status', error.response.status, error.response.data)
  // return Promise.reject(error)
  if (error.response) {
    return parseError(error.response.status, error.response.data)
  } else {
    return Promise.reject(error)
  }
})

export const CancelToken = axios.CancelToken;
export default instance;
